import LayoutConfirmDuplicateModal from './LayoutConfirmDuplicateModal';

export default LayoutConfirmDuplicateModal;
